export default __webpack_public_path__ + "static/media/FP_FR_GR_F.d66be416.png";